module.exports = __webpack_public_path__ + "static/media/Developmenticon07@2x.25d269f3.png";